module.exports = __webpack_public_path__ + "img/pr-8.694b6f61.png";